import { createSelector } from 'reselect'
import { getSelectedScene } from 'models/compositions/selectors'
import { getCanvasWidth } from 'models/location/selectors'

import isMobile from 'utils/isMobile'

export const quickPreviewIsOpen = (state) => state.preview.quickPreviewIsOpen
export const getIsCurrentDragValid = (state) => state.preview.isCurrentDragValid
export const getIsMagicWindowLoading = (state) => state.preview.isMagicWindowLoading
export const getInitialLoading = (state) => state.preview.initialLoading
export const getPreviewSettingsRaw = (state) => state.preview.settings
export const getWallDataDimensions = (state) => state.preview.wallDataDimensions

export const getPreviewSettings = createSelector(
    [getPreviewSettingsRaw, getIsMagicWindowLoading, getSelectedScene, getCanvasWidth],
    (settings, isMagicWindowLoading, scene, canvasWidth) => ({
        ...settings,
        wallCollisions: scene ? !!scene.isStock : false,
        collectFrameMetric: !isMagicWindowLoading,
        showItemLoaders: !isMagicWindowLoading,
        disableOutline: isMobile(),
        canvasWidth,
    }),
)
